<template>
    <div>
    <!-- Blog post list section -->
    <section class="section">
        <div class="container">
            <ais-instant-search :search-client="searchClient" index-name="prod_RECIPES">
                <div class="search-panel">
                    <div class="search-panel__results">
                        <div class="columns">
                        <div class="column is-one-quarter">
                            <ais-search-box 
                            placeholder="" 
                            class="searchbox recipe-search"
                            v-model="searchInput"
                            autofocus>
                                <div slot="submit-icon"><b-icon
                                    pack="fas"
                                    icon="search">
                                </b-icon></div>
                                <div slot="reset-icon">
                                <b-icon
                                    pack="fas"
                                    icon="times">
                                </b-icon></div>
                            </ais-search-box>
                            <small class="has-text-grey-lighter has-text-weight-bold"><em>Search Instantly!</em></small>
                        </div>
                        <div class="column is-three-quarters">
                            <h3 class="is-size-4">Meal Time</h3>
                            <ais-menu attribute="mealType" class="recipe-filter" />
                            <h3 class="is-size-4">Dish Type</h3>
                            <ais-menu attribute="dishType" class="recipe-filter" />
                        </div>
                    </div>
                        <app-infinite-hits>
                            <template slot="item" slot-scope="{ item }" v-if="item.status == 'published'">                            
                                <figure class="image">
                                    <img v-if="item.mainImage.length" :src="'https://firebasestorage.googleapis.com/v0/b/mymeatloaf-app.appspot.com/o/' + item.mainImage[0] + '?alt=media'">
                                    <img v-else src="https://bulma.io/images/placeholders/480x480.png">
                                </figure>  

                                <div class="middle">
                                    <div class="top-left">
                                        <p class="recipe-card-title">
                                            <router-link :to="{name: 'recipe', params: {id: item.id, slug: item.slug}}">  
                                                {{item.name}}   
                                            </router-link>
                                            
                                        </p>                                  
                                        <p class="has-text-white">Made By 
                                            <router-link :to="{name: 'Kitchen', params: {id: item.user_id}}">
                                                <strong class="has-text-white">{{item.kitchen_name}}</strong>
                                            </router-link>
                                        </p> 
                                    </div>
                                    <div class="top-right">
                                        <Like :recipe="item" :key="item.id"></Like>
                                    </div>
                                    <div class="bottom-left">
                                        <time class="has-text-white">{{ item.created_at | moment("from", "now") }}</time>   
                                    </div>
                                    <div class="bottom-right">
                                        <button class="button is-primary add-rounded" slot="trigger"                            
                                            @click="openModal(item.id)">
                                            <b-icon icon="plus"></b-icon>
                                        </button>
                                        
                                    </div>
                                </div>  
                            </template>
                        </app-infinite-hits>
                    </div>
                </div>
            </ais-instant-search>
        </div>
    </section>
    <b-modal :active.sync="isComponentModalActive"
            has-modal-card
            trap-focus
            aria-role="dialog"
            aria-modal>                
        <Add :userMeals="user_meals" :menus="menus" :selectedRecipe="selectedRecipe" :userData="userData"></Add>
    </b-modal> 
    </div>
</template>



<script>
import { mapState, mapActions } from 'vuex';
import firebase from '@/firebase';
import db from '@/db';
import Like from '../components/Like.vue';
import Add from '../components/Add.vue';
import algoliasearch from 'algoliasearch/lite';
import 'instantsearch.css/themes/algolia-min.css';
import AppInfiniteHits from '../components/InfiniteHits';


export default {
    data() {
        return {
            searchClient: algoliasearch(
                '24ZHOUI139',
                'dbfb6eed836c749ac72642c5c687f7ae'
            ),
            isComponentModalActive: false,
            selectedRecipe:null,
            userData: null,
            searchInput:null
        };
    },
    mounted() {
        this.init();
        let user = firebase.auth().currentUser;
        if (user) {
        db.collection('users').doc(firebase.auth().currentUser.uid)
            .get().then(docSnapshot => {
                if (!docSnapshot.exists) return;
                this.userData = docSnapshot.data();
            });
        }
        this.searchInput = this.$route.query.query;
    },
    components: {
        Like,
        Add,
        AppInfiniteHits
    },
    computed: mapState('recipes', ['recipes', 'user_meals', 'menus', 'user']),
    methods: {
        openModal(recipe) {            
            if(this.userData) {
                this.isComponentModalActive = true;
                this.selectedRecipe = recipe;
            }
            else {
                console.log('sdf')
            }            
        },
        ...mapActions('recipes', ['init']),
    }
};
</script>
